import { render, staticRenderFns } from "./BrandVideo.vue?vue&type=template&id=316d85cf&scoped=true&"
import script from "./BrandVideo.vue?vue&type=script&lang=ts&"
export * from "./BrandVideo.vue?vue&type=script&lang=ts&"
import style0 from "./BrandVideo.vue?vue&type=style&index=0&id=316d85cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316d85cf",
  null
  
)

export default component.exports